import { Text } from '@naf/text';
import styled from '@emotion/styled';

export const BoldText = styled(Text)`
  font-weight: 700;
`;
